export const TranslateBaseBilling = (bases) => {
    try {
      return (bases || []).map((base) => {
        return { name: base }
      })
    } catch (error) {
      console.log('error', error)
      return bases || []
    }
  }
  